<template>
  <section class="world-background-green">
    <cards-roulette :options="options" :type="'requester_company_types'" />
  </section>
</template>

<script>
import RequesterCompanyTypes from '@/constants/requester_company_types.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'

export default {
  mixins: [OnBoardStepMixin],
  components: { CardsRoulette },
  data() {
    return {
      options: RequesterCompanyTypes
    }
  }
}
</script>
